export default "__VITE_ASSET__9968b33c__"